module.exports = __webpack_public_path__ + "images/00667b8e.img1-chs@1x.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img1-chs@1x.png
// module id = 395
// module chunks = 0